module.exports = __webpack_public_path__ + "img/product-preview-60.ede1e12.png";